import {
  InputCheckboxListOption,
} from '../../../../../../types/interfaces/input.interface';
import { ColumnStepBase } from './column-step-base';

export class ColumnStepAlarm extends ColumnStepBase {
  column: InputCheckboxListOption[] = [
    {value: 'device_eui', label: 'common.fields.device-eui', isTranslated: true},
    {value: 'model', label: 'common.fields.model', isTranslated: true},
    {value: 'address', label: 'common.fields.address', isTranslated: true},
    {value: 'alarmType', label: 'common.fields.alarm-type', isTranslated: true},
    {value: 'status', label: 'common.fields.status', isTranslated: true},
    {value: 'severity', label: 'common.fields.severity', isTranslated: true},
    {value: 'created_at', label: 'common.fields.created', isTranslated: true},
  ];

  constructor() {
    super([
      'device_eui',
      'model',
      'address',
      'alarmType',
      'status',
      'severity',
      'created_at',
    ]);
  }
}
